import { createElement, memo, useEffect, useState } from '@max/max';
import './index.scss';
import { LX_CONFIG } from './type/const';
import { API_PATH, commonParams2RequestParams } from './utils/request';
import ListContainer from './components/list-container';
import { RequestType, useRequestList } from './hooks/useRequestList';
import { VerticalDoubleItem } from './components/goods-small-card';
import { getUserInfo } from '@nibfe/mkt-user-api';
import { useMonitorEngineContext } from '@nibfe/mcp-monitor-sdk';
export const DEFAULT_CITY_ID = 1;
const CrossGoodsList = (feConfig) => {
    let ctx = useMonitorEngineContext();
    const commonParams = ctx?._runtimeInfo?.commonParams ?? {};
    const { activityId, pageSize, supplyId, loadMoreType, scene, showType } = feConfig;
    const { data, requestList, listStatus, loadMoreStatus, isLastPage } = useRequestList();
    const [cityId, setCityId] = useState(commonParams?.cityInfo?.cityId ?? commonParams?.cityInfo?.locCityId ?? DEFAULT_CITY_ID);
    const [isReceivedCityChange, setIsReceivedCityChange] = useState(false);
    const [userInfo, setUserInfo] = useState({
        userId: commonParams?.userId,
        token: commonParams?.token
    });
    const loadCrossGoodsData = async (requestType) => {
        const requestConfig = {
            path: API_PATH.CROSS_SUPPLY_DELIVERY,
            method: 'POST',
            params: {
                ...commonParams2RequestParams(commonParams),
                userId: userInfo.userId,
                token: userInfo.token,
                supplyId,
                activityId,
                cityId: cityId ? Number(cityId) : DEFAULT_CITY_ID,
                scene,
                pageSize: pageSize
            },
            onNetworkSuccess: () => ctx._raptorReport.monitorReportNetworkSuccess(),
            onNetworkFailed: () => ctx._raptorReport.monitorReportNetworkFailed(),
            onBizSuccess: () => ctx._raptorReport.monitorReportBizSuccess(),
            onBizFailed: () => ctx._raptorReport.monitorReportBizFailed()
        };
        if (requestType === RequestType.INIT) {
            requestList({
                requestConfig
            }, requestType);
        }
        if (requestType === RequestType.LOAD_MORE) {
            requestConfig.params = {
                ...requestConfig.params,
                globalId: data?.globalId
            };
            requestList({
                requestConfig
            }, requestType);
        }
    };
    useEffect(() => {
        ctx?._communication?.on('cityChanged', (city) => {
            if (city?.value) {
                if (typeof city.value === 'string') {
                    setCityId(Number(city.value));
                }
                else {
                    setCityId(city.value);
                }
            }
            else {
                setCityId(DEFAULT_CITY_ID);
            }
            setIsReceivedCityChange(true);
        });
        if (!userInfo.userId || !userInfo.token) {
            if (typeof ctx?._userAPI?.forceLogin === 'function') {
                ctx._userAPI.forceLogin().then(res => {
                    const { userId, token } = ctx._runtimeInfo.commonParams;
                    if (userId && token) {
                        setUserInfo({
                            userId,
                            token
                        });
                    }
                });
            }
            else {
                getUserInfo().then((res) => {
                    const { userId, token } = res;
                    if (userId && token) {
                        setUserInfo({
                            userId,
                            token
                        });
                    }
                });
            }
        }
        return () => {
            ctx?._communication?.off('cityChanged');
        };
    }, []);
    useEffect(() => {
        if (userInfo.userId && userInfo.token) {
            if (feConfig.isRelatedCityFilter && !isReceivedCityChange) {
                return;
            }
            loadCrossGoodsData(RequestType.INIT);
        }
    }, [cityId, userInfo, isReceivedCityChange, feConfig.isRelatedCityFilter]);
    const listContainerStyle = {
        backgroundColor: feConfig.bgColor
    };
    return <>
      <ListContainer vo={{
        list: data?.list ?? []
    }} feConfig={feConfig} onContainerShow={() => {
        ctx._LXReport?.mvReport(LX_CONFIG.COMP_MV_BID, {
            valLab: {
                _moduleId: ctx._moduleId ?? '-999',
                tex_id: ctx?._runtimeInfo?.queryParams?.pageId ?? '-999',
                custom: {
                    click_biz_line: feConfig.click_biz_line ?? '-999',
                    hotel_channel: ctx?._runtimeInfo?.queryParams?.hotelchannel ?? '-999'
                }
            }
        });
    }} onRetry={() => {
        loadCrossGoodsData(RequestType.INIT);
    }} ChildComponent={VerticalDoubleItem} onLoadMore={() => {
        loadCrossGoodsData(RequestType.LOAD_MORE);
    }} onCardShow={() => {
        console.log('onCardShow');
    }} onCardClick={() => {
        console.log('onCardClick');
    }} listStatus={listStatus} loadMoreStatus={loadMoreStatus} loadMoreType={loadMoreType} isLastPage={isLastPage} showType={showType} listContainerStyle={listContainerStyle}/>
    </>;
};
export default memo(CrossGoodsList);
